import { ProbabilityShareType } from '../enums/probability-share-type.enum';
import { interpolateTemplate } from '../utils/interpolate-template.util';

/** Tokenized templates — single source for admin defaults + runtime share text. */
export const PROBABILITY_SHARE_TEXT_TEMPLATES: Record<ProbabilityShareType, string> = {
	[ProbabilityShareType.EVENT]:
		'How well can you predict what happens next? Join the World Prediction League and test your forecasting skills on the questions shaping our world.',
	[ProbabilityShareType.LOCKED_IN]:
		'I just submitted a {probability}% forecast for question "{question}".\n\nWhat’s your forecast?',
	[ProbabilityShareType.MATCH_RESULTS]:
		'I scored {rbp} points in the {matchName} challenge.\n\nCan you do better? Can you top my score?',
	[ProbabilityShareType.RANK]:
		"I'm ranked #{rank} in the World Prediction League.\n\nThink you can climb higher?",
	[ProbabilityShareType.PROFILE]:
		'I’ve made {count} forecasts and I’m ranked #{rank} globally in the World Prediction League.\n\nJoin me and put your judgment to the test.',
};

export interface ProbabilityShareText {
	description: (params: Record<string, string>) => string;
}

export const PROBABILITY_SHARE_TEXTS: Record<ProbabilityShareType, ProbabilityShareText> = {
	[ProbabilityShareType.EVENT]: {
		description: (params) =>
			interpolateTemplate(PROBABILITY_SHARE_TEXT_TEMPLATES[ProbabilityShareType.EVENT], params),
	},
	[ProbabilityShareType.MATCH_RESULTS]: {
		description: (params) =>
			interpolateTemplate(
				PROBABILITY_SHARE_TEXT_TEMPLATES[ProbabilityShareType.MATCH_RESULTS],
				params
			),
	},
	[ProbabilityShareType.PROFILE]: {
		description: (params) =>
			interpolateTemplate(PROBABILITY_SHARE_TEXT_TEMPLATES[ProbabilityShareType.PROFILE], params),
	},
	[ProbabilityShareType.RANK]: {
		description: (params) =>
			interpolateTemplate(PROBABILITY_SHARE_TEXT_TEMPLATES[ProbabilityShareType.RANK], params),
	},
	[ProbabilityShareType.LOCKED_IN]: {
		description: (params) =>
			interpolateTemplate(PROBABILITY_SHARE_TEXT_TEMPLATES[ProbabilityShareType.LOCKED_IN], params),
	},
};

/** Resolve per-event admin template, or fall back to the shared default. */
export function resolveProbabilityShareDescription(
	type: ProbabilityShareType,
	params: Record<string, string>,
	perEventTemplate?: string | null
): string {
	const template =
		typeof perEventTemplate === 'string' && perEventTemplate.trim()
			? perEventTemplate
			: PROBABILITY_SHARE_TEXT_TEMPLATES[type];
	return interpolateTemplate(template, params);
}
